module.exports = __webpack_public_path__ + "static/q13_x-df6cb2abcb23974fb163089fd2d97694.png";